<x-chartist [data]="areaData" [type]="'Line'" [options]="areaOptions" class="height-300">
</x-chartist>